module.exports = new Promise(resolve => {
    const formattedAppName = 'oap-web'
    const appName = 'oap_web'
    const cacheKey = 'remoteBranch-' + formattedAppName

    // Get branch name with localStorage caching
    const getBranchName = () => {
      const cachedBranch = localStorage.getItem(cacheKey)
      if (cachedBranch) {
        console.debug('Using cached branch for', appName, cachedBranch)
        return cachedBranch
      }
      const branchName = window.remotes?.[appName] || 'main'
      localStorage.setItem(cacheKey, branchName)
      return branchName
    }

    // Resolve remote URL based on environment
    const getRemoteURL = () => {
      const branchName = getBranchName()

      // Marina always uses local HTTPS URL
      if (branchName === 'marina') {
        return 'https://' + formattedAppName + '.local.calendly-internal.com/remoteEntry.js'
      }

      // Local development
      if (window.location.hostname.includes('local')) {
        return 'http://' + formattedAppName + '.local.calendly-internal.com/remoteEntry.js'
      }

      // Review environments
      if (window.location.href.includes('review')) {
        return 'https://assets-' + window.location.hostname + '/mfe/' + formattedAppName + '/' + branchName + '/remoteEntry.js'
      }

      // DevSpaces environments
      if (window.location.href.includes('spaces')) {
        return 'https://assets-devspaces.calendly.com/mfe/' + formattedAppName + '/' + branchName + '/remoteEntry.js'
      }

      // Staging environment
      if (window.location.href.includes('staging')) {
        // Signadot sandboxes use assets-devspaces as their asset host
        if (window.WEBPACK_PUBLIC_PATH?.includes('//assets-devspaces.calendly.com/')) {
          return 'https://assets-devspaces.calendly.com/mfe/' + formattedAppName + '/' + branchName + '/remoteEntry.js'
        }
        return 'https://assets-staging.calendly.com/mfe/' + formattedAppName + '/remoteEntry.js'
      }

      // Production
      return 'https://assets.calendly.com/mfe/' + formattedAppName + '/remoteEntry.js'
    }

    // Create and configure script tag
    const script = document.createElement('script')
    script.src = getRemoteURL()
    script.async = true
    script.crossOrigin = 'anonymous'

    // Handle successful script load
    script.onload = () => {
      // Try formatted name first, then original name
      const remoteEntry = window[formattedAppName] || window[appName]
      
      if (!remoteEntry) {
        console.error('Remote entry "' + appName + '" not found on window after script load')
        resolve({
          get: () => Promise.reject(new Error('Remote ' + appName + ' not available')),
          init: () => console.warn('Remote ' + appName + ' not available')
        })
        return
      }

      // Resolve with remoteEntry directly (not a proxy) so that Module Federation's
      // loadEntry hook can properly wrap remoteEntryExports.get() with runtime plugins
      // (retry-plugin, performance-plugin). If we create a proxy here, the proxy's
      // get() method would have a closure over remoteEntry and bypass the wrapped version.
      // By resolving with remoteEntry directly, Module Federation will pass it to
      // loadEntry hooks, plugins will wrap it, and all calls will go through the wrapped version.
      resolve(remoteEntry)
    }

    // Handle script load errors
    script.onerror = () => {
      console.error('Failed to load remote entry for', appName)
      localStorage.removeItem(cacheKey) // Clear stale cache
      resolve({
        get: () => Promise.reject(new Error('Remote ' + appName + ' not available')),
        init: () => console.warn('Remote ' + appName + ' not available')
      })
    }

    // Inject script into document
    document.head.appendChild(script)
  });